export enum WorkspaceAction {
  INVITE = "invite",
  SELECT_WORKPLACE = "selectWorkplace",
  JOIN = "join",
  LAUNCH = "launch",
  LAUNCH_WITH_2FA = "launchWorkplaceWith2FASetup",
  NAVIGATE_TO_GLOBAL_VIEW = "navigateToGlobalView",
}

export enum MspWorkspaceAction {
  CREATE_CHILD_WORKSPACE = "createChildMspWorkspace",
  CREATE_CHANNEL_WORKSPACE = "createChannelMspWorkspace",
  CREATE_REGULAR_WORKSPACE = "createRegularWorkspace",
  EDIT_WORKSPACE = "editWorkspace",
  DELETE_WORKSPACE = "deleteWorkspace",
  VIEW_WORKSPACE = "viewWorkspace",
  CONVERT = "convertWorkspace",
  EXPORT_WORKSPACES_LIST = "exportMsp",
  EDIT_SUBSCRIPTION = "editMspSubscription",
  START_SUBSCRIPTION = "startMspSubscription",
  STOP_SUBSCRIPTION = "stopMspSubscription",
  EDIT_SUBSCRIPTION_CONFIRMATION = "editMspSubscriptionConfirmation",
  EXPORT_MSP_NOTIFICATIONS = "exportMspNotifications",
  EXPORT_MSP_SUMMARY = "exportMspSummary",
  ARCHIVE_WORKSPACE = "archiveMspWorkspace",
  UNARCHIVE_WORKSPACE = "unarchiveMspWorkspace",
  EXTEND_TRIAL = "extendMspTrial",
  VIEW_PROTECTED_USERS = "viewProtectedUsers",
  VIEW_DEVICES = "viewDevices",
  VIEW_TICKETS = "viewTickets",
  BULK_SUBSCRIPTION_CONFIRMATION = "mspBulkSubscriptionChangeConfirmation",
  START_BULK_SUBSCRIPTION = "startBulkMspSubscription",
  STOP_BULK_SUBSCRIPTION = "stopBulkMspSubscription",
  EDIT_MSP_WORKSPACE_LABEL = "editMspWorkspaceLabel",
  ADD_MSP_BULK_LABEL = "addBulkMspLabel",
  ASSIGN_GLOBAL_POLICY = "assignGlobalPolicy",
  ASSIGN_GLOBAL_POLICY_CONFIRMATION = "mspAssignGlobalPolicyConfirmation",
}
export enum WorkspaceType {
  CHANNEL = "channel",
  CHILD = "child",
  REGULAR = "regular",
}

export enum SubscriptionBundle {
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  EMAIL_PROTECTION = "emailProtection",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  MANAGED_EMAIL_PROTECTION = "managedEmailProtection",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  SASE = "sase",
  /**
   * @deprecated
   */
  MANAGED_SASE = "managedSase",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  CORO_ESSENTIALS = "coroEssentials",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  MANAGED_CORO_ESSENTIALS = "managedCoroEssentials",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  CORO_CLASSIC = "coroClassic",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  MANAGED_CORO_CLASSIC = "managedCoroClassic",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  CORO_COMPLETE = "coroComplete",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  MANAGED_CORO_COMPLETE = "managedCoroComplete",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  ENDPOINT_PROTECTION = "endpointProtection",
  /**
   * This bundle is now a LEGACY bundle.
   * @deprecated
   */
  MANAGED_ENDPOINT_PROTECTION = "managedEndpointProtection",

  CORO_AI_ESSENTIALS = "coroAIEssentials",
  MANAGED_CORO_AI_ESSENTIALS = "managedCoroAIEssentials",

  CORO_AI_ENDPOINT = "coroAIEndpoint",
  MANAGED_CORO_AI_ENDPOINT = "managedCoroAIEndpoint",

  CORO_AI_COMPLETE = "coroAIComplete",
  MANAGED_CORO_AI_COMPLETE = "managedCoroAIComplete",

  CORO_AI_LITE = "coroAILite",
  MANAGED_CORO_AI_LITE = "managedCoroAILite",
}

export enum SubscriptionModule {
  CLOUD_SECURITY = "cloudSecurity",
  ENDPOINT_SECURITY = "endpointSecurity",
  EMAIL_SECURITY = "emailSecurity",
  USER_DATA_GOVERNANCE = "userDataGovernance",
  ENDPOINT_DATA_GOVERNANCE = "endpointDataGovernance",
  EDR = "edr",
  NETWORK = "network",
  MDM = "mdm",
  SECURITY_AWARENESS_TRAINING = "securityAwarenessTraining",
  SWG = "securedWebGateway",
}

export type TicketGeneratingSubscriptionModule =
  | SubscriptionModule.CLOUD_SECURITY
  | SubscriptionModule.ENDPOINT_SECURITY
  | SubscriptionModule.EMAIL_SECURITY
  | SubscriptionModule.USER_DATA_GOVERNANCE
  | SubscriptionModule.ENDPOINT_DATA_GOVERNANCE
  | SubscriptionModule.EDR;

export enum SubscriptionAddon {
  SOC_CLOUD = "socCloudSecurity",
  SOC_ENDPOINT = "socEndpointSecurity",
  SOC_EMAIL = "socEmailSecurity",
  SOC_USER_DATA_GOVERNANCE = "socUserDataGovernance",
  SOC_ENDPOINT_DATA_GOVERNANCE = "socEndpointDataGovernance",
  SOC_NETWORK = "socNetwork",
  SOC = "soc",
  MDR = "mdr",
  WIFI_PHISHING = "wifiPhishing",
  SECURED_MESSAGES = "securedMessages",
  INBOUND_GATEWAY = "inboundGateway",
  OUTBOUND_GATEWAY = "outboundGateway",
  ZTNA = "zeroTrustNetworkAccess",
}

export const bundlesContent: Record<
  SubscriptionBundle,
  { addons: SubscriptionAddon[]; modules: SubscriptionModule[] }
> = {
  [SubscriptionBundle.EMAIL_PROTECTION]: {
    addons: [
      // SubscriptionAddon.OUTBOUND_GATEWAY, todo: uncomment when implemented
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    modules: [SubscriptionModule.EMAIL_SECURITY, SubscriptionModule.USER_DATA_GOVERNANCE],
  },
  [SubscriptionBundle.MANAGED_EMAIL_PROTECTION]: {
    addons: [
      // SubscriptionAddon.OUTBOUND_GATEWAY, todo: uncomment when implemented
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_EMAIL,
      SubscriptionAddon.SOC_USER_DATA_GOVERNANCE,
    ],
    modules: [SubscriptionModule.EMAIL_SECURITY, SubscriptionModule.USER_DATA_GOVERNANCE],
  },
  [SubscriptionBundle.SASE]: {
    addons: [
      // SubscriptionAddon.ZTNA todo: uncomment when implemented
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.NETWORK,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.MANAGED_SASE]: {
    addons: [
      // SubscriptionAddon.ZTNA, todo: uncomment when implemented
      SubscriptionAddon.SOC_CLOUD,
      SubscriptionAddon.SOC_NETWORK,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.NETWORK,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.CORO_ESSENTIALS]: {
    addons: [SubscriptionAddon.WIFI_PHISHING],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EDR,
      SubscriptionModule.EMAIL_SECURITY,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_ESSENTIALS]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.MDR,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_EMAIL,
      SubscriptionAddon.SOC_CLOUD,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EDR,
      SubscriptionModule.EMAIL_SECURITY,
    ],
  },
  [SubscriptionBundle.CORO_CLASSIC]: {
    addons: [SubscriptionAddon.WIFI_PHISHING],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.USER_DATA_GOVERNANCE,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_CLASSIC]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_EMAIL,
      SubscriptionAddon.SOC_CLOUD,
      SubscriptionAddon.SOC_USER_DATA_GOVERNANCE,
      SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.USER_DATA_GOVERNANCE,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
    ],
  },
  [SubscriptionBundle.CORO_COMPLETE]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.USER_DATA_GOVERNANCE,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
      SubscriptionModule.NETWORK,
      SubscriptionModule.MDM,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_COMPLETE]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_EMAIL,
      SubscriptionAddon.SOC_CLOUD,
      SubscriptionAddon.SOC_USER_DATA_GOVERNANCE,
      SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE,
      SubscriptionAddon.SOC_NETWORK,
      SubscriptionAddon.MDR,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.USER_DATA_GOVERNANCE,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
      SubscriptionModule.NETWORK,
      SubscriptionModule.MDM,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.ENDPOINT_PROTECTION]: {
    addons: [SubscriptionAddon.WIFI_PHISHING],
    modules: [
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
    ],
  },
  [SubscriptionBundle.CORO_AI_ENDPOINT]: {
    addons: [SubscriptionAddon.WIFI_PHISHING],
    modules: [
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
    ],
  },
  [SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE,
      SubscriptionAddon.MDR,
    ],
    modules: [
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE,
      SubscriptionAddon.MDR,
    ],
    modules: [
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
    ],
  },
  [SubscriptionBundle.CORO_AI_COMPLETE]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.USER_DATA_GOVERNANCE,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
      SubscriptionModule.NETWORK,
      SubscriptionModule.MDM,
      SubscriptionModule.SECURITY_AWARENESS_TRAINING,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_AI_COMPLETE]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_EMAIL,
      SubscriptionAddon.SOC_CLOUD,
      SubscriptionAddon.SOC_USER_DATA_GOVERNANCE,
      SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE,
      SubscriptionAddon.SOC_NETWORK,
      SubscriptionAddon.MDR,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.USER_DATA_GOVERNANCE,
      SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
      SubscriptionModule.EDR,
      SubscriptionModule.NETWORK,
      SubscriptionModule.MDM,
      SubscriptionModule.SECURITY_AWARENESS_TRAINING,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.CORO_AI_ESSENTIALS]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.EDR,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS]: {
    addons: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_CLOUD,
      SubscriptionAddon.SOC_ENDPOINT,
      SubscriptionAddon.SOC_EMAIL,
      SubscriptionAddon.MDR,
    ],
    modules: [
      SubscriptionModule.CLOUD_SECURITY,
      SubscriptionModule.ENDPOINT_SECURITY,
      SubscriptionModule.EMAIL_SECURITY,
      SubscriptionModule.EDR,
      SubscriptionModule.SWG,
    ],
  },
  [SubscriptionBundle.CORO_AI_LITE]: {
    addons: [SubscriptionAddon.SECURED_MESSAGES, SubscriptionAddon.INBOUND_GATEWAY],
    modules: [SubscriptionModule.CLOUD_SECURITY, SubscriptionModule.EMAIL_SECURITY],
  },
  [SubscriptionBundle.MANAGED_CORO_AI_LITE]: {
    addons: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_CLOUD,
      SubscriptionAddon.SOC_EMAIL,
    ],
    modules: [SubscriptionModule.CLOUD_SECURITY, SubscriptionModule.EMAIL_SECURITY],
  },
};

export const modulesAndAddonsInBundleConfiguration: Record<
  SubscriptionBundle,
  { [key in SubscriptionModule]?: SubscriptionAddon[] }
> = {
  [SubscriptionBundle.CORO_CLASSIC]: {
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.EMAIL_SECURITY]: [],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [],
  },
  [SubscriptionBundle.MANAGED_CORO_CLASSIC]: {
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.EMAIL_SECURITY]: [SubscriptionAddon.SOC_EMAIL],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_USER_DATA_GOVERNANCE],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE],
  },
  [SubscriptionBundle.ENDPOINT_PROTECTION]: {
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [],
    [SubscriptionModule.EDR]: [],
  },
  [SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION]: {
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE],
    [SubscriptionModule.EDR]: [SubscriptionAddon.MDR],
  },
  [SubscriptionBundle.CORO_AI_ENDPOINT]: {
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [],
    [SubscriptionModule.EDR]: [],
  },
  [SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT]: {
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE],
    [SubscriptionModule.EDR]: [SubscriptionAddon.MDR],
  },
  [SubscriptionBundle.EMAIL_PROTECTION]: {
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [], // todo: SubscriptionAddon.OUTBOUND_GATEWAY
  },
  [SubscriptionBundle.MANAGED_EMAIL_PROTECTION]: {
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_EMAIL,
    ],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_USER_DATA_GOVERNANCE], // todo: SubscriptionAddon.OUTBOUND_GATEWAY
  },
  [SubscriptionBundle.SASE]: {
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.NETWORK]: [], // todo SubscriptionAddon.ZTNA
    [SubscriptionModule.SWG]: [],
  },
  [SubscriptionBundle.MANAGED_SASE]: {
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.NETWORK]: [SubscriptionAddon.SOC_NETWORK], // todo SubscriptionAddon.ZTNA
    [SubscriptionModule.SWG]: [],
  },
  [SubscriptionBundle.CORO_ESSENTIALS]: {
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.EDR]: [],
    [SubscriptionModule.EMAIL_SECURITY]: [],
  },
  [SubscriptionBundle.MANAGED_CORO_ESSENTIALS]: {
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.EDR]: [SubscriptionAddon.MDR],
    [SubscriptionModule.EMAIL_SECURITY]: [SubscriptionAddon.SOC_EMAIL],
  },

  [SubscriptionBundle.CORO_COMPLETE]: {
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [],
    [SubscriptionModule.EDR]: [],
    [SubscriptionModule.NETWORK]: [],
    [SubscriptionModule.MDM]: [],
    [SubscriptionModule.SWG]: [],
  },
  [SubscriptionBundle.MANAGED_CORO_COMPLETE]: {
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_EMAIL,
    ],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_USER_DATA_GOVERNANCE],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE],
    [SubscriptionModule.EDR]: [SubscriptionAddon.MDR],
    [SubscriptionModule.NETWORK]: [SubscriptionAddon.SOC_NETWORK],
    [SubscriptionModule.MDM]: [],
    [SubscriptionModule.SWG]: [],
  },

  [SubscriptionBundle.CORO_AI_COMPLETE]: {
    [SubscriptionModule.SECURITY_AWARENESS_TRAINING]: [],
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [],
    [SubscriptionModule.EDR]: [],
    [SubscriptionModule.NETWORK]: [],
    [SubscriptionModule.MDM]: [],
    [SubscriptionModule.SWG]: [],
  },

  [SubscriptionBundle.MANAGED_CORO_AI_COMPLETE]: {
    [SubscriptionModule.SECURITY_AWARENESS_TRAINING]: [],
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_EMAIL,
    ],
    [SubscriptionModule.USER_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_USER_DATA_GOVERNANCE],
    [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE],
    [SubscriptionModule.EDR]: [SubscriptionAddon.MDR],
    [SubscriptionModule.NETWORK]: [SubscriptionAddon.SOC_NETWORK],
    [SubscriptionModule.MDM]: [],
    [SubscriptionModule.SWG]: [],
  },

  [SubscriptionBundle.CORO_AI_ESSENTIALS]: {
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.ENDPOINT_SECURITY]: [SubscriptionAddon.WIFI_PHISHING],
    [SubscriptionModule.EDR]: [],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
    [SubscriptionModule.SWG]: [],
  },

  [SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS]: {
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.ENDPOINT_SECURITY]: [
      SubscriptionAddon.WIFI_PHISHING,
      SubscriptionAddon.SOC_ENDPOINT,
    ],
    [SubscriptionModule.EDR]: [SubscriptionAddon.MDR],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_EMAIL,
    ],
    [SubscriptionModule.SWG]: [],
  },
  [SubscriptionBundle.CORO_AI_LITE]: {
    [SubscriptionModule.CLOUD_SECURITY]: [],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
    ],
  },
  [SubscriptionBundle.MANAGED_CORO_AI_LITE]: {
    [SubscriptionModule.CLOUD_SECURITY]: [SubscriptionAddon.SOC_CLOUD],
    [SubscriptionModule.EMAIL_SECURITY]: [
      SubscriptionAddon.SECURED_MESSAGES,
      SubscriptionAddon.INBOUND_GATEWAY,
      SubscriptionAddon.SOC_EMAIL,
    ],
  },
};

export const bundlesForModules = {
  [SubscriptionModule.CLOUD_SECURITY]: [
    SubscriptionBundle.SASE,
    SubscriptionBundle.MANAGED_SASE,
    SubscriptionBundle.CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.CORO_AI_LITE,
    SubscriptionBundle.MANAGED_CORO_AI_LITE,
  ],
  [SubscriptionModule.ENDPOINT_SECURITY]: [
    SubscriptionBundle.CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.EMAIL_SECURITY]: [
    SubscriptionBundle.CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.EMAIL_PROTECTION,
    SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
    SubscriptionBundle.CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.CORO_AI_LITE,
    SubscriptionBundle.MANAGED_CORO_AI_LITE,
  ],
  [SubscriptionModule.USER_DATA_GOVERNANCE]: [
    SubscriptionBundle.EMAIL_PROTECTION,
    SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
    SubscriptionBundle.CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: [
    SubscriptionBundle.CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.EDR]: [
    SubscriptionBundle.CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.NETWORK]: [
    SubscriptionBundle.SASE,
    SubscriptionBundle.MANAGED_SASE,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.MDM]: [
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.SECURITY_AWARENESS_TRAINING]: [
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionModule.SWG]: [
    SubscriptionBundle.SASE,
    SubscriptionBundle.MANAGED_SASE,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
  ],
} as const;

export const bundlesForAddons = {
  [SubscriptionAddon.SOC_CLOUD]: [
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_SASE,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_LITE,
  ],
  [SubscriptionAddon.SOC_ENDPOINT]: [
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionAddon.SOC_EMAIL]: [
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_LITE,
  ],
  [SubscriptionAddon.SOC_USER_DATA_GOVERNANCE]: [
    SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE]: [
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionAddon.SOC_NETWORK]: [
    SubscriptionBundle.MANAGED_SASE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionAddon.MDR]: [
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionAddon.WIFI_PHISHING]: [
    SubscriptionBundle.MANAGED_CORO_AI_ENDPOINT,
    SubscriptionBundle.MANAGED_ENDPOINT_PROTECTION,
    SubscriptionBundle.MANAGED_CORO_ESSENTIALS,
    SubscriptionBundle.CORO_ESSENTIALS,
    SubscriptionBundle.CORO_AI_ENDPOINT,
    SubscriptionBundle.ENDPOINT_PROTECTION,
    SubscriptionBundle.CORO_CLASSIC,
    SubscriptionBundle.MANAGED_CORO_CLASSIC,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
  [SubscriptionAddon.SECURED_MESSAGES]: [
    SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
    SubscriptionBundle.EMAIL_PROTECTION,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.CORO_AI_LITE,
    SubscriptionBundle.MANAGED_CORO_AI_LITE,
  ],
  [SubscriptionAddon.INBOUND_GATEWAY]: [
    SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
    SubscriptionBundle.EMAIL_PROTECTION,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_ESSENTIALS,
    SubscriptionBundle.MANAGED_CORO_AI_ESSENTIALS,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
    SubscriptionBundle.CORO_AI_LITE,
    SubscriptionBundle.MANAGED_CORO_AI_LITE,
  ],
  // [SubscriptionAddon.OUTBOUND_GATEWAY]: [
  //   SubscriptionBundle.MANAGED_EMAIL_PROTECTION,
  //   SubscriptionBundle.EMAIL_PROTECTION
  // ],
  [SubscriptionAddon.ZTNA]: [
    SubscriptionBundle.MANAGED_SASE,
    SubscriptionBundle.SASE,
    SubscriptionBundle.CORO_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_COMPLETE,
    SubscriptionBundle.CORO_AI_COMPLETE,
    SubscriptionBundle.MANAGED_CORO_AI_COMPLETE,
  ],
} as const;

export const addonsToModuleMap: Record<SubscriptionAddon, SubscriptionModule | null> = {
  [SubscriptionAddon.WIFI_PHISHING]: SubscriptionModule.ENDPOINT_SECURITY,
  [SubscriptionAddon.INBOUND_GATEWAY]: SubscriptionModule.EMAIL_SECURITY,
  [SubscriptionAddon.SECURED_MESSAGES]: SubscriptionModule.EMAIL_SECURITY,
  [SubscriptionAddon.MDR]: SubscriptionModule.EDR,
  [SubscriptionAddon.SOC_CLOUD]: SubscriptionModule.CLOUD_SECURITY,
  [SubscriptionAddon.SOC_ENDPOINT]: SubscriptionModule.ENDPOINT_SECURITY,
  [SubscriptionAddon.SOC_EMAIL]: SubscriptionModule.EMAIL_SECURITY,
  [SubscriptionAddon.SOC_USER_DATA_GOVERNANCE]: SubscriptionModule.USER_DATA_GOVERNANCE,
  [SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE]: SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
  [SubscriptionAddon.SOC]: null,
  [SubscriptionAddon.SOC_NETWORK]: SubscriptionModule.NETWORK,
  [SubscriptionAddon.OUTBOUND_GATEWAY]: null,
  [SubscriptionAddon.ZTNA]: null,
} as const;

export enum SubscriptionType {
  INITIAL = "initial",
  FREEZE = "freeze",
  TRIAL = "trial",
  SUBSCRIPTION = "subscription",
  ARCHIVED = "archived",
}

export const defaultSubscriptionModulesConfig = {
  [SubscriptionModule.CLOUD_SECURITY]: {
    enabled: false,
    addons: [
      {
        enabled: false,
        name: SubscriptionAddon.SOC_CLOUD,
      },
    ],
  },
  [SubscriptionModule.ENDPOINT_SECURITY]: {
    enabled: false,
    addons: [
      {
        enabled: false,
        name: SubscriptionAddon.WIFI_PHISHING,
      },
      {
        enabled: false,
        name: SubscriptionAddon.SOC_ENDPOINT,
      },
    ],
  },
  [SubscriptionModule.EMAIL_SECURITY]: {
    enabled: false,
    addons: [
      {
        enabled: false,
        name: SubscriptionAddon.SECURED_MESSAGES,
      },
      {
        enabled: false,
        name: SubscriptionAddon.INBOUND_GATEWAY,
      },
      {
        enabled: false,
        name: SubscriptionAddon.SOC_EMAIL,
      },
    ],
  },
  [SubscriptionModule.SECURITY_AWARENESS_TRAINING]: {
    enabled: false,
    addons: [],
  },
  [SubscriptionModule.USER_DATA_GOVERNANCE]: {
    enabled: false,
    addons: [
      // todo: uncomment when implemented
      // {
      //   enabled: false,
      //   name: SubscriptionAddon.OUTBOUND_GATEWAY
      // },
      {
        enabled: false,
        name: SubscriptionAddon.SOC_USER_DATA_GOVERNANCE,
      },
    ],
  },
  [SubscriptionModule.ENDPOINT_DATA_GOVERNANCE]: {
    enabled: false,
    addons: [
      {
        enabled: false,
        name: SubscriptionAddon.SOC_ENDPOINT_DATA_GOVERNANCE,
      },
    ],
  },
  [SubscriptionModule.EDR]: {
    enabled: false,
    addons: [
      {
        enabled: false,
        name: SubscriptionAddon.MDR,
      },
    ],
  },
  [SubscriptionModule.NETWORK]: {
    enabled: false,
    addons: [
      // todo: uncomment when implemented
      // {
      //   enabled: false,
      //   name: SubscriptionAddon.ZTNA
      // },
      {
        enabled: false,
        name: SubscriptionAddon.SOC_NETWORK,
      },
    ],
  },
  [SubscriptionModule.MDM]: {
    enabled: false,
    addons: [],
  },
  [SubscriptionModule.SWG]: {
    enabled: false,
    addons: [],
  },
};

export enum SubscriptionsFilterType {
  ADDON = "addon",
  BUNDLE = "bundle",
  MODULE = "module",
}

export enum WorkspaceLocale {
  EN_US = "en-US",
  EN_GB = "en-GB",
  ES = "es",
  IT = "it",
  FR = "fr",
  FR_CA = "fr-CA",
  DE = "de",
}

export enum WorkspaceNavigationButton {
  GLOBAL = "globalView",
  WORKSPACE = "workspaceView",
}

export enum CoroBanner {
  OUTBOUND_GATEWAY_MONITOR_ONLY = "outboundGatewayMonitorOnly",
  OUTBOUND_GATEWAY_BLOCK_MODE = "outboundGatewayBlockMode",
  OUTBOUND_GATEWAY_SETUP = "outboundGatewaySetup",
}
